<template>
  <div class="tw-flex tw-flex-col tw-gap-0.5">
    <h3 v-if="teamMember" class="tw-font-semibold tw-text-lg tw-text-[#001240] tw-capitalize">
      Hello, {{ `${teamMember.fname} ${teamMember.lname}` }}
    </h3>
    <h3 v-else class="tw-font-semibold tw-text-lg tw-text-[#001240]">
      Hello, {{ details.name }}
    </h3>
    <p class="tw-text-sm tw-text-[#64748B]">We're glad to have you.</p>
  </div>
</template>

<script>
import { getItem } from "@/utils/storage.js";

export default {
  name: "WelcomeText",

  data() {
    return {
      details: {},
      teamMember: null,
    };
  },

  mounted() {
    this.details = getItem("org_details");
    this.teamMember = getItem("team_member");
  },
};
</script>

<style lang="scss" scoped></style>
